import { render, staticRenderFns } from "./LocalDashboardView.vue?vue&type=template&id=dd3a7918&"
import script from "./LocalDashboardView.vue?vue&type=script&lang=js&"
export * from "./LocalDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./LocalDashboardView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports